<template>
  <b-nav-item v-once class="d-md-down-none" @click="asideToggle">
    <i class="icon-info"></i>
  </b-nav-item>
</template>

<script>
import { toggleClasses, asideMenuCssClasses } from '@utils/design/toggle-info'

export default {
  props: {
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    display: {
      type: String,
      default: 'lg',
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classList() {
      return ['navbar-toggler']
    },
  },

  mounted: function() {
    this.toggle(this.defaultOpen)
  },

  methods: {
    toggle(force) {
      let display = 'lg'
      toggleClasses(asideMenuCssClasses[0], asideMenuCssClasses, force)
      toggleClasses(`aside-menu-${display}-show`, asideMenuCssClasses, force)
    },

    asideToggle(e) {
      e.preventDefault()
      this.toggle()
    },
  },
}
</script>

<style>
.icon-info {
  color: #666666;
}
</style>
